import { createFeatureSelector } from '@ngrx/store';
import { ClubsCreateNewState, ClubsSearchState, ClubsTabState } from '../models/clubs.models';
import { ClubsCreateNewReducer } from './clubs-create-new.reducer';
import { ClubsSearchReducer } from './clubs-search.reducer';
import { ClubsTabReducer } from './clubs.reducer';

export const featureClubsName = 'Clubs';

export interface DragonflyClubsState {
  search: ClubsSearchState;
  createNew: ClubsCreateNewState;
  clubsTab: ClubsTabState;
}

export const moduleClubsReducers = {
  search: ClubsSearchReducer,
  createNew: ClubsCreateNewReducer,
  clubsTab: ClubsTabReducer,
};

export const getDragonflyClubsState = createFeatureSelector<DragonflyClubsState>(featureClubsName);
